import {State} from '../types'

export const getDatesInformation = (state: State) => {
  return state.dates.events[state.event.id]
}
